export const environment = {
  production: false,
  api: 'https://api-dev.icheck.com.vn',
  icheck: 'http://sandbox.icheck.com.vn',
  apiIcheck: 'https://core.icheck.com.vn',
  // api_evs: "https://api-qrcode-dev.icheck.com.vn", //sanbox
  api_evs: 'https://qrcode-test-api.icheck.vn', //sanbox

  // api_evs: "https://api-qrcheck.icheck.vn",
  // api_evs: "https://qrcode-livetest-api.icheck.vn", //live
  idIcheckAdmin: 'i-1512962009445',
  loyalty: 'https://loyalty.dev.icheck.vn',
  // firebase: {
  //   apiKey: "AIzaSyAYf-V6sdmiDOeLPbHzgL7DN9Awzb2gZ6o",
  //   authDomain: "icheck-dev-d9f70.firebaseapp.com",
  //   databaseURL: "https://icheck-dev-d9f70.firebaseio.com",
  //   projectId: "icheck-dev-d9f70",
  //   storageBucket: "icheck-dev-d9f70.appspot.com",
  //   messagingSenderId: "738064619121",
  // },
  firebase: {
    apiKey: 'AIzaSyAuPrD4Ad3-nTqS3H_erFjAsnjzhL_9oGI',
    authDomain: 'mideaapplication.firebaseapp.com',
    databaseURL: 'https://mideaapplication-default-rtdb.firebaseio.com',
    projectId: 'mideaapplication',
    storageBucket: 'mideaapplication.appspot.com',
    messagingSenderId: '1096253511080',
    appId: '1:1096253511080:web:4b862b84f298abe545399d',
    measurementId: 'G-TPHP2BCKBP'
  },

  facebook: {
    appId: '1465397716834916',
    // appId: '906784082696285',
    cookie: true, // enable cookies to allow the server to access
    // the session
    xfbml: true, // parse social plugins on this page
    version: 'v2.8', // use graph api version 2.8
  },
  google: {
    client_id:
      '873655301603-2a03gvlji6n9m84e9qrm7ieg4jl0fvac.apps.googleusercontent.com',
    scope: 'profile',
  },
  walletUrl: 'https://shop.icheck.com.vn',
  serverImg: 'http://icheckcdn.net/images/original',
  imageUpload:
    'https://upload.icheck.vn/v1/images?uploadType=multipart&responseType=json',

  //http://sandbox.icheck.com.vn:4345/encode/download?start=1&end=200&batch_id=32&prefix=PPU&domain=http://ktra.vn/
  // linkDownloadBatch: "http://sandbox.icheck.com.vn:4381/encode/download",
  linkDownloadBatch: "https://qrcode-test-api.icheck.vn/encode/download",
  linkDownloadBatchVer2: 'https://cms-qcheck.dev.icheck.vn/qr-hash/api/v1/encode/download',
  // domainQrcode: 'http://ktra.vn/',
  // domainQrcode: "http://qcheck.vn/",
  domainQrcode: 'http://dev-qcheck.icheck.vn/',
  // url_static_stamp: "http://cd.qcheck.vn",
  url_static_stamp: 'http://cd-dev.qcheck.vn',
  url_static_image: 'http://icheckcdn.net/images/720x720',
  url_static_image_id: 'https://upload.icheck.vn/hi',
  url_seller: 'https://api.dev.icheck.vn/api/v1',
  apiBaseUrlBusiness: 'https://api.dev.icheck.vn/api/v1',
  // qrcode_url: "https://qrcode-livetest-api.icheck.vn/qr_aps", //live
  qrcode_url: 'https://qrcode-test-api.icheck.vn/qr_aps', //qrcode
  qrcode_url_aps: 'https://qrcode-test-api.icheck.vn/qr-core-aps',
  qrcode_url_reset_pass: 'https://qrcode-test-api.icheck.vn/user-management', //qrcodez
  qrcode_support: 'https://api-qrcheck.icheck.vn/qr_aps_support',
  // qrcode_url: "https://api-qrcheck.icheck.vn/qr_aps", //qrcode
  // apiDatahubUrl:
  //   "https://datahub-livetest-businessapi.icheck.vn/business/api/v1",
  appIdTracking: "7512a611-179f-4270-8b1e-b2ad59b6b2c7",
  uploadUrlNew: "https://up.icheck.com.vn/upload/stream",
  accountBacthIcheck: [782021, 1],
  /* Tuanba: 3-1-2023: Môi trường icheck, đăng ký tài khoản icheck */
  url_icheck: 'https://apiv2.dev.icheck.vn',
  // Tuanba:14-11-2023: Cấu hình phường xã cho các doanh nghiệp
  wardBussiness: [],
  // Tuanba:14-11-2023: Cấu hình ẩn quận huyện cũ cho các doanh nghiệp
  districtBusiness: [2231008, 2231007],
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts